// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__28YTa","choiceBoxes":"toolbarselects_choiceBoxes__da8qJ","simpleField":"toolbarselects_simpleField__QTH7x"};